import type React from 'react'

interface DetailSectionProps {
  icon: React.ReactNode
  label: string
  count: number
  children: React.ReactNode
}

export function DetailSection({ icon, label, count, children }: DetailSectionProps) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginBottom: 12,
          padding: '0 2px',
        }}
      >
        {icon}
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--foreground)' }}>{label}</span>
        <span
          style={{
            fontSize: 11,
            color: 'var(--muted-foreground)',
            fontFamily: 'var(--font-mono)',
            fontVariantNumeric: 'tabular-nums',
          }}
        >
          {count}
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{children}</div>
    </div>
  )
}
